var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 10,
    viewBox: "0 0 9 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.914 5.00895C7.394 5.16095 7.77 5.41695 8.042 5.77695C8.314 6.12895 8.45 6.56495 8.45 7.08495C8.45 7.82095 8.162 8.38895 7.586 8.78895C7.018 9.18095 6.186 9.37695 5.09 9.37695H0.746V0.976953H4.85C5.874 0.976953 6.658 1.17295 7.202 1.56495C7.754 1.95695 8.03 2.48895 8.03 3.16095C8.03 3.56895 7.93 3.93295 7.73 4.25295C7.538 4.57295 7.266 4.82495 6.914 5.00895ZM2.678 2.44095V4.42095H4.61C5.09 4.42095 5.454 4.33695 5.702 4.16895C5.95 4.00095 6.074 3.75295 6.074 3.42495C6.074 3.09695 5.95 2.85295 5.702 2.69295C5.454 2.52495 5.09 2.44095 4.61 2.44095H2.678ZM4.946 7.91295C5.458 7.91295 5.842 7.82895 6.098 7.66095C6.362 7.49295 6.494 7.23295 6.494 6.88095C6.494 6.18495 5.978 5.83695 4.946 5.83695H2.678V7.91295H4.946Z",
    fill: "#464953"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBold);
export default __webpack_public_path__ + "static/media/bold.688430bb2d5a75c1b984b1fbc05cd305.svg";
export { ForwardRef as ReactComponent };